import { AdminPricingService } from '@shared/services/admin-pricing.service';
import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { LeadsService } from '@shared/services/leads.service';
import { DartboardTableService } from '@core/dartboard/table/table-data.service';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-kpis',
  templateUrl: './kpis.component.html',
  styleUrls: ['./kpis.component.scss'],
  host: {
    class: ''
  }
})
export class KpisComponent implements OnInit, OnDestroy {

  @Input() jobs;
  @Input() numberSold: number;
  @Input() numberLost: number;
  @Input() numberPending: number;
  @Input() soldJobs: any[] = []

  totalSales
  totalEnhancementsSold
  averageTimeToClose
  leadTypeBreakdown: { [key: string]: { total: number, sold: number, pending: number, lost: number } } = {};

  consultantFilterSub: Subscription;
  // closeRateJobs: any[] = [];

  constructor(
    public adminPricingService : AdminPricingService,
    public leadsService: LeadsService,
    public dartboardTableService: DartboardTableService,
  ) { 

  }

  ngOnDestroy(): void {
    this.consultantFilterSub?.unsubscribe()
  }

  ngOnChanges(changes: SimpleChanges): void {
    const jobs = changes['jobs']?.currentValue
    if (jobs != changes['jobs']?.previousValue) {
      this.totalEnhancementsSold = this.getEnhancementsTotal()
      this.totalSales = this.getJobsTotal()
      this.averageTimeToClose = this.getAverageTimeToClose()
    }
  }

  calculateLeadTypeBreakdown(jobs) {
    // Reset the breakdown
    this.leadTypeBreakdown = {};
    
    // Count jobs by lead type
    jobs?.forEach(job => {
      const leadType = job?.info?.leadType || 'Unknown';
      const isSold = job?.status === 'sold'
      const isPending = job?.status === 'pending'
      const isLost = job?.status === 'lost'
      this.leadTypeBreakdown[leadType] = {
        total: (this.leadTypeBreakdown[leadType]?.total || 0) + 1,
        lost: isLost ? (this.leadTypeBreakdown[leadType]?.lost || 0) + 1 : (this.leadTypeBreakdown[leadType]?.lost || 0),
        pending: isPending ? (this.leadTypeBreakdown[leadType]?.pending || 0) + 1 : (this.leadTypeBreakdown[leadType]?.pending || 0),
        sold: isSold ? (this.leadTypeBreakdown[leadType]?.sold || 0) + 1 : (this.leadTypeBreakdown[leadType]?.sold || 0)
      }
    });
  }

  ngOnInit(): void {
    this.consultantFilterSub = this.dartboardTableService.closeRateJobs$.subscribe(jobs => {
      this.calculateLeadTypeBreakdown(jobs)
    })
    // this.consultantFilterSub = this.dartboardTableService.currentFilters$.subscribe(filters => {
    //    this.dartboardTableService.dateRangeJobs$.pipe(
    //       map(jobs => filters.consultant ? jobs.filter(job => job.meta.createdBy === filters.consultant) : jobs)
    //     ).subscribe(jobs => {
    //       this.closeRateJobs = jobs
    //       this.dartboardTableService.closeRateJobs$.next(jobs)
    //       this.calculateLeadTypeBreakdown()
    //     })
    // })
  }

  getAverageTimeToClose() {
    const processedGroups = new Set();
    let totalTimespan = 0;
    let groupCount = 0;

    if (this.soldJobs.length === 0) return 0;

    this.soldJobs.forEach(job => {
      const { jobsGroupId } = job?.meta || {};

      if (jobsGroupId && processedGroups.has(jobsGroupId)) {
        return; // Skip if group already processed
      }

      processedGroups.add(jobsGroupId);
      groupCount++;

      const createdTime = new Date(job.meta.created).valueOf();
      const signedTime = job.confirmation.signedAt ? new Date(job.confirmation.signedAt).valueOf() : null;
      if (signedTime) {
        const timespan = signedTime - createdTime;
        totalTimespan += timespan;
      }
    });

    // Calculate the average timespan in milliseconds
    const averageTimespan = totalTimespan / groupCount;

    // Convert the average timespan from milliseconds to days (optional)
    const averageTimespanInDays = averageTimespan / (1000 * 60 * 60 * 24);
    return averageTimespanInDays;
  }

  getJobsTotal() {
    const processedGroups = new Set();
    const total = this.soldJobs.reduce((total, job) => {
      if (!job?.confirmation) {
        return total;
      }

      const { jobsGroupId } = job?.meta || {};
      if (jobsGroupId && processedGroups.has(jobsGroupId)) {
        return total; // Skip if group already processed
      }

      if (job?.confirmation?.prices?.total) {
        total += job?.confirmation?.prices?.total;
        processedGroups.add(jobsGroupId); // Mark group as processed
      }

      return total;
    }, 0);
    return total;
  }

  getEnhancementsTotal() {
    const processedGroups = new Set();
    const totalEnhancements = this.soldJobs.reduce((total, job) => {
      if (!job?.confirmation) {
        return total;
      }

      const { jobsGroupId } = job?.meta || {};
      if (jobsGroupId && processedGroups.has(jobsGroupId)) {
        return total; // Skip if group already processed
      }

      if (job?.confirmation?.prices?.e) {
        total += job?.confirmation?.prices?.e;
        processedGroups.add(jobsGroupId); // Mark group as processed
      }

      return total;
    }, 0);
    return totalEnhancements;
  }

}
